<template>
  <v-menu
    v-if="primeiro"
    ref="menu1"
    v-model="menu1"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="computedPrimeiroDia"
        persistent-hint
        prepend-icon="mdi-calendar"
        v-bind="attrs"
        readonly
        v-on="on"
      />
    </template>
    <v-date-picker
      v-model="primeiroDia"
      no-title
      @input="updateDate"
    />
  </v-menu>
</template>
<script>

  import utilService from '../../../../services/utils'
  export default {
    name: 'CoreFiltroData',
    emits: ['updateDados'],
    props: {
      primeiro: {
        type: Boolean,
        default: false,
      },
    },
    data: () => ({
      primeiroDia: utilService.methods.doDataHoje(),
      date: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      dateFormatted: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu1: false,
    }),

    computed: {
      computedDateFormatted () {
        return this.formatDate(this.date)
      },

      computedPrimeiroDia () {
        return utilService.methods.formatDiaMesAno(this.primeiroDia)
      },
    },
    watch: {
      date (val) {
        // this.date = this.formatDate(this.date)
       // this.dateFormatted = this.formatDate(this.date)
      },
      primeiro: function (val) {
        this.primeiro = val
      },
    },
    methods: {
      updateDate () {
        this.menu1 = false
        this.$root.$emit('update-dados', this.primeiroDia)
      },
    },

  }
</script>
